export default {
  data() {
    return {
      imageId: null,
      showModal: false,
      teaserImage: null,
    };
  },

  methods: {
    deleteImage() {
      this.teaserImage = null;
      this.imageId = null;
      this.focalPoint = {};
      this.showModal = false;
    },

    onImageDelete() {
      this.showModal = true;
    },

    setFocalPoint(focalPoint) {
      this.focalPoint = focalPoint;
    },
  },
};
